"use client";

import React from "react";
import { usePathname } from "next/navigation";
import dynamic from "next/dynamic";
import Header from "./Header";
import Footer from "./Footer";
import ScrollProgress from "@/components/ui/ScrollProgress";
import SmoothScrollProvider from "@/components/providers/SmoothScrollProvider";
import CustomCursor from "@/components/ui/CustomCursor";
import Preloader from "@/components/ui/Preloader";
import { QuoteModalProvider } from "@/context/QuoteModalContext";

const QuoteModal = dynamic(() => import("@/components/modals/QuoteModal"), { ssr: false });

export default function AppLayoutWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const isAdmin = pathname?.startsWith("/admin");

  if (isAdmin) {
    return <div className="admin-panel min-h-screen w-full flex flex-col">{children}</div>;
  }

  return (
    <QuoteModalProvider>
      <SmoothScrollProvider>
        {/* Custom spring cursor dynamics */}
        <CustomCursor />

        {/* Logo path-drawing preloader screen */}
        <Preloader />

        {/* Scroll progress viewport indicator */}
        <ScrollProgress />

        {/* Main sticky navigation */}
        <Header />

        {/* Content container */}
        <main className="flex-grow">{children}</main>

        {/* Complex footer layout */}
        <Footer />
      </SmoothScrollProvider>
      <QuoteModal />
    </QuoteModalProvider>
  );
}
